(function () {
  const TIMERS = new WeakMap();

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function readEndTs(root) {
    const ms = parseInt(root.getAttribute('data-end-ts'), 10);
    if (ms > 0) return ms;

    const endStr = root.getAttribute('data-end-time');
    if (!endStr) return 0;

    let parsed = new Date(endStr).getTime();
    if (isNaN(parsed)) {
      parsed = new Date(endStr.replace(/([+-]\d{2})(\d{2})$/, '$1:$2')).getTime();
    }
    return isNaN(parsed) ? 0 : parsed;
  }

  function initBar(root) {
    const existing = TIMERS.get(root);
    if (existing) clearInterval(existing);

    const endTs = readEndTs(root);
    if (!endTs) return;

    const onExpire = root.getAttribute('data-on-expire') || 'freeze';
    const timerEl = root.querySelector('[data-cb-timer]');
    const msgEl = root.querySelector('[data-cb-expire-message]');
    const units = Array.prototype.slice.call(root.querySelectorAll('.cb-unit'));

    function compute(now) {
      const diff = Math.max(0, endTs - now);
      let s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400);
      s -= d * 86400;
      const h = Math.floor(s / 3600);
      s -= h * 3600;
      const m = Math.floor(s / 60);
      s -= m * 60;
      return { days: d, diff: diff, hours: h, minutes: m, seconds: s };
    }

    function setUnit(unitEl, value) {
      const str = pad(value);
      const srEl = unitEl.querySelector('[data-value]');
      if (srEl && srEl.textContent !== str) srEl.textContent = str;

      const wrap = unitEl.querySelector('.cb-cards');
      if (!wrap) return;

      const cards = Array.prototype.slice.call(wrap.querySelectorAll('.cb-card'));
      if (!cards.length) return;

      while (cards.length < str.length) {
        const extra = cards[cards.length - 1].cloneNode(true);
        wrap.appendChild(extra);
        cards.push(extra);
      }
      while (cards.length > str.length && cards.length > 2) {
        wrap.removeChild(cards.pop());
      }

      for (let i = 0; i < cards.length; i++) {
        const ch = str.charAt(i);
        if (cards[i].textContent !== ch) {
          cards[i].setAttribute('data-digit', ch);
          cards[i].textContent = ch;
          cards[i].classList.remove('is-flipping');
          // force reflow so animation restarts
          void cards[i].offsetWidth;
          cards[i].classList.add('is-flipping');
        }
      }
    }

    function applyExpire() {
      if (onExpire === 'hide_section') {
        root.style.display = 'none';
      } else if (onExpire === 'show_message') {
        if (timerEl) timerEl.style.display = 'none';
        if (msgEl) msgEl.hidden = false;
      }
      // 'freeze' — leave the 00s in place
    }

    let expiredHandled = false;
    function tick() {
      const t = compute(Date.now());
      units.forEach(function (u) {
        const unit = u.getAttribute('data-unit');
        if (Object.prototype.hasOwnProperty.call(t, unit)) setUnit(u, t[unit]);
      });
      if (t.diff <= 0 && !expiredHandled) {
        expiredHandled = true;
        applyExpire();
        clearInterval(TIMERS.get(root));
        TIMERS.delete(root);
      }
    }

    tick();
    if (!expiredHandled) TIMERS.set(root, setInterval(tick, 1000));
  }

  function initAll() {
    document.querySelectorAll('[data-countdown-bar]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when theme editor re-renders the section
  document.addEventListener('shopify:section:load', function (e) {
    const root = e.target.querySelector('[data-countdown-bar]');
    if (root) initBar(root);
  });
})();
